import ImeiList from '../components/ImeiList/ImeiList';

export default function Imeis() {

    return(
            <ImeiList />
    )
}